// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer {
    background-color: #454242;
    color: #fff;
    padding: 50px 50px;
  }
  
  .footer-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-links a {
    color: #fff;
    margin-right: 30px;
    text-decoration: none;
  }
  
  .footer-info p {
    margin: 0;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    .footer-links {
      margin-bottom: 20px;
    }
    
    .footer-links a {
      margin-right: 15px;
    }
    
    .footer-info {
      text-align: center;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":["#footer {\n    background-color: #454242;\n    color: #fff;\n    padding: 50px 50px;\n  }\n  \n  .footer-content {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .footer-links a {\n    color: #fff;\n    margin-right: 30px;\n    text-decoration: none;\n  }\n  \n  .footer-info p {\n    margin: 0;\n    font-size: 14px;\n  }\n  \n  @media (max-width: 768px) {\n    .footer-links {\n      margin-bottom: 20px;\n    }\n    \n    .footer-links a {\n      margin-right: 15px;\n    }\n    \n    .footer-info {\n      text-align: center;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
